import type { MonospaceFile } from '#layers/data-model';
import { RStoreSchema } from '#imports';
import { createFileHooks } from '~/rstore/utils/collections/files';

export const File = RStoreSchema.withItemType<MonospaceFile>().defineCollection({
	name: 'MonospaceFile',
	computed: {
		$thumbnail: (item) => item,
	},
	meta: {
		defaultFields: ['id', 'fileName', 'fileSize', 'mediaType', 'title', 'description', 'tags'],
		useProjectSlug: true,
	},
	hooks: createFileHooks('project'),
});
